<template>
  <div class="PJLossReport-container">
    <div class="PJfirst">
      <el-table :data="accessoryList" border stripe highlight-current-row>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="配件名称"
          align="center"
        ></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="250px"
        >
          <template slot-scope="scope">
            <el-popconfirm
              title="确定报损该配件吗？"
              @confirm="handleConfirm(scope.row)"
              @cancel="handleCancel"
            >
              <el-button
                type="text"
                size="small"
                slot="reference"
                style="color: #ebb563"
                >报损单件</el-button
              >
            </el-popconfirm>
            <el-button
              style="color: #ebb563"
              type="text"
              size="small"
              @click="handleMultiple(scope.row)"
              >报损多件</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="配件报损" :visible.sync="dialogVisible" width="40%">
      <span>
        报损数量：
        <el-input-number v-model="count" :min="1" :max="10"></el-input-number>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleMultipleConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      dialogVisible: false,
      accessoryList: [],
      accessoryName: "",
      count: 1, // 默认份数为1
    };
  },
  created() {
    this.obtainAccessoryInfo();
  },
  methods: {
    handleCancel() {},
    handleMultiple(row) {
      this.dialogVisible = true;
      this.accessoryName = row.name;
    },
    handleMultipleConfirm(row) {
      console.log(this.accessoryName, this.count);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const outBoundApiInstance = axios.create({
        baseURL: "/outBoundApi",
      });

      //使用FormData对象发送POST请求
      //  console.log(params,'params')
      outBoundApiInstance
        .post(
          "monkeyshop/common/reportingLosses" +
            "?" +
            "reportName" +
            "=" +
            this.accessoryName +
            "&count" +
            "=" +
            this.count
        )
        .then((res) => {
          this.dialogVisible = false;
          this.count = 1;
          console.log(res, "res");
          this.$message({
            message: "配件报损成功",
            type: "success",
          });
          // this.tableData = res.data
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleConfirm(row) {
      console.log(row.name);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const outBoundApiInstance = axios.create({
        baseURL: "/outBoundApi",
      });

      //使用FormData对象发送POST请求
      //  console.log(params,'params')
      outBoundApiInstance
        .post(
          "monkeyshop/common/reportingLosses" +
            "?" +
            "reportName" +
            "=" +
            row.name +
            "&count" +
            "=1"
        )
        .then((res) => {
          console.log(res, "res");
          this.$message({
            message: "配件报损成功",
            type: "success",
          });
          // this.tableData = res.data
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    obtainAccessoryInfo() {
      this.accessoryList = [];
      axios({
        method: "post",
        url: "openApi/app/6lnic53k3k01/apply/filter",
        data: {
          pageSize: 50,
          pageNum: 1,
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          res.data.result.result.forEach((element) => {
            element.answers.forEach((item) => {
              if (item.queId == "182394186") {
                let obj = { name: item.values[0].dataValue };
                console.log(item, "item");
                this.accessoryList.push(obj);
                console.log(this.accessoryList, "this.accessoryList");
              }
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.PJLossReport-container {
  width: 100%;
  height: 700px;
}
.PJfirst {
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
  /* background-color: #d9ecff; */
  height: 480px;
}
.el-button--primary {
  color: #fff;
  background-color: #fb9337;
  border-color: #fb9337;
}
.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
  background: #fb9337;
  border-color: #fb9337;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/accessoriesLossReport.vue